<template>
  <div>
    <b-tabs pills card>
      <b-tab :title="$t('Main')">
        <b-col>
          <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="selectAccountingPeriod.length > 0" :placeholder="$t('Tap to select')"/>
              <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit && !accountingPeriodId"/>
              <b-form-invalid-feedback id="inputFeedback">
                {{ $t('Select accounting period') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-select :options="listOfChargePolicy" v-model="ipTrafficService.policy_id"/>
              <b-input-group-append>
                <b-button variant="info" size="sm" @click="showFormChargePolicies">{{ $t('Details') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select  :disabled="isEdit && ipTrafficService.scheme_id > 0" :options="listOfCoefficientScheme" v-model="ipTrafficService.scheme_id" @change="coeffSchemeChanged"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input :disabled="ipTrafficService.scheme_id > 0" type="number" v-model="ipTrafficService.cost_coef"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
            <b-input-group>
              <b-form-input type="text" v-model="ipTrafficService.charged_in_curr_period" disabled/>
              <b-input-group-append>
                <b-button variant="info" size="sm" @click="showFormCharged">{{ $t('Details') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-tab>
      <b-tab :title="$t('Additional')">
        <b-col>
          <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <flat-picker :key="rerenderStartDate"
            :isDisabled="isEdit"
            @onDateChanged="(unixDate) => {ipTrafficService.start_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(ipTrafficService.start_date ? ipTrafficService.start_date : new Date()/1000 ).toDate())}"
            />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <flat-picker :key="rerenderExpireDate"
            :isDisabled="infinityDate"
            @onDateChanged="(unixDate) => {ipTrafficService.expire_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(ipTrafficService.expire_date ? ipTrafficService.expire_date : new Date()/1000 ).toDate())}"
            />
            <b-form-checkbox v-model="infinityDate">{{ $t('Infinity date') }}</b-form-checkbox>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-input type="text" disabled v-model="userHouse" :placeholder="$t('Tap to select')"/>
              <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
              <b-input-group-append>
                <b-button variant="secondary" size="sm" @click="clear">{{ $t('Clear') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Address comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="ipTrafficService.house_comment"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="ipTrafficService.comment"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Bandwidth limit')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
            <b-input-group>
              <b-form-input type="text" v-model="dynamicShaping" disabled/>
              <b-input-group-append>
                <b-button variant="info" size="sm" @click="showTurboMode">{{ $t('Turbo') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-tab>
      <b-tab :title="$t('IP groups')" :active="tabIPGroups">
        <b-row>
          <b-col>
            <md-button @click.stop="showAddIPGroups" class="md-raised md-dense">{{ $t('Add') }}</md-button>
          </b-col>
        </b-row>
        <b-table small striped hover :items="IPGroups" :fields="fieldsIPGroups" @row-clicked="rowClickHandlerIPGroups">
          <template v-slot:cell(actions)="row">
            <i @click.stop="ClickOnEditIPGroupsButton(row)" class="primary fa fa-edit fa-lg" />
            <i @click.stop="ClickOnDeleteIPGroupsButton(row)" class="danger fa fa-trash-alt fa-lg"/>
          </template>
        </b-table>
      </b-tab>
      <b-tab :title="$t('Quotas')">
        <b-row>
          <b-col>
            <md-button @click.stop="showAddQuotas" class="md-raised md-dense">{{ $t('Add') }}</md-button>
          </b-col>
        </b-row>
        <b-table small striped hover :items="Quotas" :fields="fieldsQuotas" @row-clicked="rowClickHandlerQuotas">
          <template v-slot:cell(actions)="row">
            <i @click.stop="ClickOnEditQuotasButton(row)" class="primary fa fa-edit fa-lg" />
            <i @click.stop="ClickOnDeleteQuotasButton(row)" class="danger fa fa-trash-alt fa-lg"/>
          </template>
        </b-table>
      </b-tab>
      <b-tab :title="$t('Radius parameters')">
        <b-row>
          <b-col>
              <md-button class="md-raised md-dense" @click="swohAddRadiusAttr">{{ $t('Add') }}</md-button>
            </b-col>
          </b-row>
          <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
            <template v-slot:cell(actions)="row">
              <i @click.stop="ClickOnEditRadiusAttrButton(row)" class="primary fa fa-edit fa-lg"/>
              <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg"/>
            </template>
          </b-table>
        </b-tab>
    </b-tabs>

    <modal-ok-cancel @save="saveServiceLink" @cancel="hideSelectService" size="lg"/>

    <b-modal ref="modalIPGroups" hide-footer :title="$t('IP groups')" size="lg">
      <b-tabs pills vertical card>
        <b-tab ref="tab_ip_settings" lazy :title="$t('IP settings')" :key="rerender_tab_ip_settings">
          <b-col class="mt-3">
            <b-form-group label-align="right" :label="$t('IPv4 subnet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
               <b-input-group>
                <b-form-input v-model="newIPGroups.ipv4" :disabled="selectedDhcpPool !== 0 || selectedRadiusPool.length !== 0 || newIPGroups.ipv6 !== ''"/>
                <div v-if="!selectedRadiusPool || selectedDhcpPool !== 0">
                  <b-input-group-append >
                    <i @click.stop="showFormfreeIP()" style="margin: 8px 10px;" class="fa fa-duotone fa-bars fa-lg"/>
                  </b-input-group-append>
                </div>
              </b-input-group>

            </b-form-group>
            <b-form-group label-align="right" :label="$t('IPv6 subnet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
              <b-form-input v-model="newIPGroups.ipv6" :disabled="selectedDhcpPool !== 0 || selectedRadiusPool.length !== 0 || newIPGroups.ipv4 !== ''"/>
              <b-input-group-append >
                <i @click.stop="showFormfreeIPv6()" style="margin: 8px 10px;" class="fa fa-duotone fa-bars fa-lg"/>
              </b-input-group-append>
            </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Dynamic')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox switch v-model="isDynamic" disabled/>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('RADIUS settings')">
          <b-col class="mt-3">
            <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" @change="updateIPGroupLogin" v-model="newIPGroups.login"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="newIPGroups.password"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('RADIUS pool')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input v-model="selectedRadiusPool"></b-form-input>
                  <b-input-group-append>
                    <b-form-select :options="listOfRadiusPool" v-model="selectedRadiusPool"/>
                  </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Allowed CID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="newIPGroups.allowed_cid"/>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('DHCP settings')">
          <b-col class="mt-3">
            <b-form-group label-align="right" :label="$t('Mac address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="newIPGroups.mac"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Switch')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="switchName" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showSwitch"/>
                <b-input-group-append>
                  <b-button variant="secondary" size="sm" @click="clearSwitch">{{ $t('Clear') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Port')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input id="input-port" type="number" v-model="newIPGroups.port_id" :state="portState" aria-describedby="input-port-feedback" :disabled="newIPGroups.switch_id === 0"/>
              <b-form-invalid-feedback id="input-port-feedback">
                {{$t('Port busy')}}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" label="VlAN ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="newIPGroups.vlan_id" :disabled="newIPGroups.switch_id === 0"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Dynamic DHCP pool')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="listToShowOfDhcpPool" v-model="selectedDhcpPool">
                <template slot="first">
                  <option :value="0">{{ $t('not select') }}</option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group>
              <b-button variant="info" size="sm" @click="showAdditionalFeatures">{{ $t('DHCP Options') }}</b-button>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('Additional settings')">
          <b-col class="mt-3">
            <b-form-group label-align="right" :label="$t('NetFlow provider')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="listOfNetFlow" v-model="selectedNetFlow"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Not VPN IP groups')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox switch v-model="isNotVPN"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Do not affect firewall rules')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox switch v-model="isNotFirewall"/>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('ISG attributes settings')">
          <b-row>
            <b-col>
              <h4 style="font-weight:bold">{{ $t('Name') }}</h4>
            </b-col>
            <b-col>
              <h4 style="font-weight:bold">{{ $t('Attribute ID') }}</h4>
            </b-col>
            <b-col>
              <h4 style="font-weight:bold">{{ $t('Vendor ID') }}</h4>
            </b-col>
            <b-col>
              <h4 style="font-weight:bold">{{ $t('Value') }}</h4>
            </b-col>
          </b-row>
          <b-row v-for="ISG in ISGattrs" v-bind:key="ISG.id" style="border-top: 1px solid #dee2e6; margin-right: 0px">
            <b-col>
              <p style="position: absolute; top: 50%; transform: translate(0, -50%)">{{ ISG.attr_name }}</p>
            </b-col>
            <b-col>
              <p style="position: absolute; top: 50%; transform: translate(0, -50%)">{{ ISG.attr_id }}</p>
            </b-col>
            <b-col>
              <p style="position: absolute; top: 50%; transform: translate(0, -50%)">{{ ISG.vendor_id }}</p>
            </b-col>
            <b-col>
              <b-input v-model="ISG.isg_attr_value" style="background-image: none"/>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
      <modal-ok-cancel @save="addIPGroups" @cancel="hideIPGroups" size="lg"/>
    </b-modal>

    <b-modal ref="modalSwitch" hide-footer :title="$t('Selection switch')" size="lg">
      <b-table small striped hover :items="switchTable" :fields="fieldsSwitch" @row-clicked="rowClickHandlerSwitch"/>
      <modal-ok-cancel @save="addSwitch" @cancel="hideSwitch" size="lg"/>
    </b-modal>

    <b-modal ref="modalQuotas" hide-footer :title="$t('Quota')">
      <b-form-group label-align="right" :label="$t('Traffic class')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select :options="listOfQuotas" v-model="selectedQuotas" :disabled="isEditQuotas === true"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Quota')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="newQuotas.traffic_quota"/>
      </b-form-group>

      <modal-ok-cancel @save="addQuotas" @cancel="hideQuotas"/>
    </b-modal>

    <b-modal hide-footer ref="modalOption"  :title="$t('Option')">
      <b-form-group label-align="right" :label="$t('Option ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="newOpt.option_id"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select  :options="dhcpOptsTypes" type="text" v-model="newOpt.type"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Value')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="newOpt.value"/>
      </b-form-group>
      <b-form-group style="margin-top:-2%" label-align="right" :label="$t('Force Add')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-checkbox switch v-model="newOpt.flag"></b-checkbox>
      </b-form-group>
        <modal-ok-cancel @save="optSubmit" @cancel="hidemodalOption" size="md"/>
    </b-modal>

    <b-modal hide-footer ref="MOption125"  :title="$t('Option 125 (Vendor-Specific Information)')">
      <option125 ref="Option125"/>
      <modal-ok-cancel @save="saveOpt125" @cancel="$refs.MOption125.hide()" size="md"/>
    </b-modal>
    <b-modal ref="modalDHCPoptions" hide-footer :title="$t('DHCP options detail')" size="lg">

      <b-form>
      <md-button class="md-raised" @click="showmodalOption">{{ $t('Add') }}</md-button>
      <md-button class="md-raised" @click="$refs.MOption125.show()" >{{ $t('Add Option 125') }}</md-button>
      <b-table striped hover small
        :items="dhcpOptionsList"
        :fields="dhcpOptionsFields">
        <template v-slot:cell(actions)="row">
          <i @click.stop="ClickOnDeleteOptsButton(row)" class="danger fa fa-trash-alt fa-lg"/>
      </template>
      <template v-slot:cell(flag)="row">
          <b-form-checkbox disabled switch size="sm" v-model="row.item.flag"/>
      </template>
      </b-table>
    </b-form>

    <modal-ok-cancel @save="addDHCPOptionsToIPGroup" @cancel="hideAdditionalFeatures" size="lg"/>
    </b-modal>

    <b-modal ref="accoutingPeriod" hide-footer :title="$t('Accounting period')" size="xl">
      <FormAccountinfPeriod
        v-model="ipTrafficService.accounting_period_id"
        @hideAccoutingPeriod="hideAccoutingPeriod"/>
    </b-modal>

    <b-modal ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse v-model="ipTrafficService.house_id" @hideFormHouse="hideFormHouse"></FormHouse>
    </b-modal>

    <b-modal ref="freeIp" hide-footer :title="$t('IP zones')" size="xl">
      <FormIPZones :isV4="isV4" @IPselected="IPselected" @hideFormfreeIP="hideFormfreeIP"></FormIPZones>
    </b-modal>

    <b-modal ref="detailChargePolicies" hide-footer size="lg">
      <FormChargePolicies v-if="currentChargePolicy" @hideFormChargePolicies="hideFormChargePolicies" :currentChargePolicy="currentChargePolicy"/>
    </b-modal>

    <b-modal ref="turboMode" hide-footer :title="$t('Turbo Mode')">
      <FormTurboMode :currentService="currentService" @hideTurboMode="hideTurboMode"/>
    </b-modal>

    <b-modal ref="detailCharge" hide-footer :title="$t('Periodic service statisticsperiod')">
      <FormCharged @hideFormCharged="hideFormCharged" :currentService="currentService"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @edited="editRadiusAttr"
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import FormAccountinfPeriod from './formAccountingPeriod'
import FormHouse from '@/pages/users/usersAndGroups/detail/contacts/formHouse.vue'
import FormChargePolicies from '@/pages/tariffication/additional/chargePolicies/editModal.vue'
import FormTurboMode from './formTurboMode'
import FormCharged from './formCharged'
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'
import option125 from '@/components/option125.vue'
import FormIPZones from './formas/formFreeIp.vue'
export default {
  components: {
    FormAccountinfPeriod,
    FormHouse,
    FormChargePolicies,
    FormTurboMode,
    FormCharged,
    FormRadiusAttributs,
    option125,
    FormIPZones
  },
  props: {
    listOfCoefficientScheme: null,
    listOfChargePolicy: null,
    tariffLinkId: 0,
    accountingPeriodId: 0,
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null
  },
  data () {
    return {
      switchIpPortBinding: null,
      selectSwitch: null,
      isV4: true,
      rerender_tab_ip_settings: 0,
      rerenderStartDate: 0,
      rerenderExpireDate: 0,
      isOptsModifiedFlag: false,
      dhcpOptsTypes: [{value: 1, text: this.$i18n.t('Number')},
        {value: 2, text: this.$i18n.t('String')},
        {value: 3, text: this.$i18n.t('IP address')},
        {value: 4, text: this.$i18n.t('Binary')},
        {value: 5, text: this.$i18n.t('IP address array')}],

      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isValRadiuspool: false,
      flagNotVPN: 1,
      flagNotFirewall: 2,
      flagDynamic: 4,
      flagDelegatedIPv6: 512,
      isNotVPN: false,
      isNotFirewall: false,
      isDynamic: false,
      isDelegatedIPv6: false,
      newDHCPoptions: {
        option: {id: 1, type: 3},
        values: ''
      },
      dhcpOptionsList: [],
      DHCPoptionsValues: [],
      DHCPoptionsValuesIds: 0,
      selectedAdditionalFeaturesType: '',
      DHCPoptionsType: [
        {value: 1, text: this.$i18n.t('INT')},
        {value: 2, text: this.$i18n.t('STRING')},
        {value: 3, text: 'IP'},
        {value: 4, text: this.$i18n.t('BINARY')},
        {value: 5, text: this.$i18n.t('IP_ARRAY')}
      ],
      selectedAdditionalFeatures: '',
      DHCPoptions: [
        {value: {id: 1, type: 3}, text: 'subnet-mask {derived}'},
        {value: {id: 2, type: 1}, text: 'time-offset'},
        {value: {id: 3, type: 5}, text: 'routers'},
        {value: {id: 4, type: 5}, text: 'time-servers'},
        {value: {id: 5, type: 5}, text: 'name-servers'},
        {value: {id: 6, type: 5}, text: 'domain-name-servers'},
        {value: {id: 7, type: 5}, text: 'log-servers'},
        {value: {id: 8, type: 5}, text: 'cookie-servers'},
        {value: {id: 9, type: 5}, text: 'lpr-servers'},
        {value: {id: 10, type: 5}, text: 'impress-servers'},
        {value: {id: 11, type: 5}, text: 'resource-location-servers'},
        {value: {id: 12, type: 2}, text: 'host-name'},
        {value: {id: 13, type: 4}, text: 'boot-size'},
        {value: {id: 14, type: 2}, text: 'merit-dump'},
        {value: {id: 15, type: 2}, text: 'domain-name'},
        {value: {id: 16, type: 3}, text: 'swap-server'},
        {value: {id: 17, type: 2}, text: 'root-path'},
        {value: {id: 18, type: 2}, text: 'extensions-path'},
        {value: {id: 19, type: 1}, text: 'ip-forwarding'},
        {value: {id: 20, type: 1}, text: 'non-local-source-routing'},
        {value: {id: 21, type: 5}, text: 'policy-filters'},
        {value: {id: 22, type: 4}, text: 'max-dgram-reassembly'},
        {value: {id: 23, type: 4}, text: 'default-ip-ttl'},
        {value: {id: 24, type: 1}, text: 'path-mtu-aging-timeout'},
        {value: {id: 25, type: 4}, text: 'path-mtu-plateau-tables'},
        {value: {id: 26, type: 4}, text: 'interface-mtu'},
        {value: {id: 27, type: 1}, text: 'all-subnets-local'},
        {value: {id: 28, type: 3}, text: 'broadcast-address'},
        {value: {id: 29, type: 1}, text: 'perform-mask-discovery'},
        {value: {id: 30, type: 1}, text: 'mask-supplier'},
        {value: {id: 31, type: 1}, text: 'router-discovery'},
        {value: {id: 32, type: 3}, text: 'router-solicitation-address'},
        {value: {id: 33, type: 5}, text: 'static-routes'},
        {value: {id: 34, type: 1}, text: 'trailer-encapsulation'},
        {value: {id: 35, type: 1}, text: 'arp-cache-timeout'},
        {value: {id: 36, type: 1}, text: 'ieee802.3-encapsulation'},
        {value: {id: 37, type: 4}, text: 'default-tcp-ttl'},
        {value: {id: 38, type: 1}, text: 'tcp-keepalive-interval'},
        {value: {id: 39, type: 1}, text: 'tcp-keepalive-garbage'},
        {value: {id: 40, type: 2}, text: 'nis-domain'},
        {value: {id: 41, type: 5}, text: 'nis-servers'},
        {value: {id: 42, type: 5}, text: 'ntp-servers'},
        {value: {id: 43, type: 4}, text: 'vendor-encapsulated-options'},
        {value: {id: 44, type: 5}, text: 'netbios-name-servers'},
        {value: {id: 45, type: 5}, text: 'netbios-dd-servers'},
        {value: {id: 46, type: 4}, text: 'netbios-node-type'},
        {value: {id: 47, type: 2}, text: 'netbios-scope'},
        {value: {id: 48, type: 5}, text: 'font-servers'},
        {value: {id: 49, type: 5}, text: 'x-display-managers'},
        {value: {id: 50, type: 3}, text: 'dhcp-requested-address {set by DHCP client}'},
        {value: {id: 51, type: 1}, text: 'dhcp-lease-time'},
        {value: {id: 52, type: 4}, text: 'dhcp-option-overload'},
        {value: {id: 53, type: 4}, text: 'dhcp-message-type {set by protocols}'},
        {value: {id: 54, type: 3}, text: 'dhcp-server-identifier {set by DHCP server}'},
        {value: {id: 55, type: 4}, text: 'dhcp-parameter-request-list'},
        {value: {id: 57, type: 4}, text: 'dhcp-max-message-size {set by protocol}'},
        {value: {id: 58, type: 1}, text: 'dhcp-renewal-time'},
        {value: {id: 59, type: 1}, text: 'dhcp-rebinding-time'},
        {value: {id: 60, type: 2}, text: 'dhcp-class-identifier {set by DHCP client}'},
        {value: {id: 61, type: 4}, text: 'dhcp-client-identifier {set by DHCP client}'},
        {value: {id: 62, type: 2}, text: 'netwareip-domain'},
        {value: {id: 63, type: 4}, text: 'netwareip-information'},
        {value: {id: 64, type: 2}, text: 'nis+-domain'},
        {value: {id: 65, type: 5}, text: 'nis+-servers'},
        {value: {id: 66, type: 2}, text: 'tftp-server'},
        {value: {id: 67, type: 2}, text: 'boot-file'},
        {value: {id: 68, type: 5}, text: 'mobile-ip-home-agents'},
        {value: {id: 69, type: 5}, text: 'smtp-servers'},
        {value: {id: 70, type: 5}, text: 'pop3-servers'},
        {value: {id: 71, type: 5}, text: 'nntp-servers'},
        {value: {id: 72, type: 5}, text: 'www-servers'},
        {value: {id: 73, type: 5}, text: 'finger-servers'},
        {value: {id: 74, type: 5}, text: 'irc-servers'},
        {value: {id: 75, type: 5}, text: 'streettalk-servers'},
        {value: {id: 76, type: 5}, text: 'streettalk-directory-assistance-servers'},
        {value: {id: 77, type: 2}, text: 'dhcp-user-class-id {set by DHCP client}'},
        {value: {id: 81, type: 4}, text: ' client-fqdn'},
        {value: {id: 82, type: 4}, text: 'relay-agent-info'},
        {value: {id: 85, type: 5}, text: 'nds-servers'},
        {value: {id: 86, type: 2}, text: 'nds-tree'},
        {value: {id: 87, type: 2}, text: 'nds-context'},
        {value: {id: 118, type: 3}, text: 'subnet-selection'},
        {value: {id: 121, type: 3}, text: 'classless-route'},
        {value: {id: 122, type: 4}, text: 'cablelabs-client-configuration'},
        {value: {id: 128, type: 3}, text: 'mcns-security-server'},
        {value: {id: 185, type: 4}, text: 'vpn-id'},
        {value: {id: 220, type: 4}, text: 'cisco-subnet-allocation'},
        {value: {id: 221, type: 4}, text: 'cisco-vpn-id'},
        {value: {id: 251, type: 4}, text: 'auto-configure'}
      ],
      ISGattrs: [],
      selectIPGroups: null,
      listToShowOfDhcpPool: [],
      dynamicShapingIn: 'NA',
      dynamicShapingOut: 'NA',
      dynamicShaping: '',
      switchName: '',
      currentChargePolicy: null,
      selectedQuotas: 0,
      selectedDhcpPool: 0,
      selectedNetFlow: 0,
      selectQuotas: null,
      selectedRadiusPool: '',
      editDocumentImage: require('@/assets/img/document_edit.png'),
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      infinityDate: true,
      isEditIPGroups: false,
      isEditQuotas: false,
      isShowHouseUser: false,
      ipTrafficService: {
        'house_comment': '',
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tplink_id': 0,
        'scheme_id': 0,
        'accounting_period_id': 0,
        'start_date': moment().unix(),
        'expire_date': moment(2000000000 * 1000).unix(),
        'policy_id': 1,
        'cost_coef': 100,
        'house_id': 0,
        'comment': '',
        'unabon': 0,
        'unprepay': 0,
        'ip_group': [
          {
            'ip': '0.0.0.0',
            'mask': 0,
            'mac': '',
            'login': '',
            'allowed_cid': '',
            'password': '',
            'pool_name': '',
            'flags': 0,
            'nfprovider_id': 0,
            'switch_id': 0,
            'port_id': 0,
            'vlan_id': 0,
            'pool_id': 0,
            'owner_id': 0,
            'owner_type': 0,
            'dhcp_options': [],
            'isg_attrs': []
          }
        ],
        'traffic_quota': []
      },
      emptyIPGroups: {
        'login': '',
        'password': '',
        'mac': '',
        'allowed_cid': '',
        'pool_name': '',
        'pool_id': 0,
        'switch_id': 0,
        'ip': '',
        'vlan_id': 0,
        'port_id': 0,
        'nfprovider_id': 0,
        'flags': 0,
        'ipv4': '',
        'ipv6': '',
        'dhcp_options': [],
        'isg_attrs': [],
        'mask': 0,
        'owner_id': 0,
        'owner_type': 0
      },
      newIPGroups: {
        'login': '',
        'password': '',
        'mac': '',
        'allowed_cid': '',
        'pool_name': '',
        'pool_id': 0,
        'switch_id': 0,
        'ip': '',
        'vlan_id': 0,
        'port_id': 0,
        'nfprovider_id': 0,
        'flags': 0,
        'ipv4': '',
        'ipv6': '',
        'dhcp_options': [],
        'isg_attrs': [],
        'mask': 0,
        'owner_id': 0,
        'owner_type': 0
      },
      newQuotas: {
        'tclass': 0,
        'traffic_quota': 0,
        'name': ''
      },
      emptyQuotas: {
        'tclass': 0,
        'traffic_quota': 0,
        'name': ''
      },
      newOpt: {
        'option_id': '',
        'type': '',
        'value': '',
        'flag': false
      },
      emptyOpt: {
        'option_id': '',
        'type': '',
        'value': '',
        'flag': false
      },
      tabIPGroups: false,
      ipTrafficServiceEdit: null,
      IPGroups: [],
      fieldsIPGroups: [
        {key: 'ipv4', label: this.$i18n.t('IPv4 subnet'), sortable: true},
        {key: 'ipv6', label: this.$i18n.t('IPv6 subnet'), sortable: true},
        {key: 'mac', label: this.$i18n.t('MAC address'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'allowed_cid', label: this.$i18n.t('Allowed CID'), sortable: true},
        {key: 'pool_id', label: this.$i18n.t('DHCP pool id'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      Quotas: [],
      fieldsQuotas: [
        {key: 'tclass', label: this.$i18n.t('Class ID'), sortable: true},
        {key: 'name', label: this.$i18n.t('Traffic class name'), sortable: true},
        {key: 'traffic_quota', label: this.$i18n.t('Quota'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      fieldsSwitch: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'address', label: 'IP', sortable: true}
      ],
      dhcpOptionsFields: [
        {key: 'option_id', label: this.$i18n.t('Option ID'), sortable: true},
        {key: 'type',
          label: this.$i18n.t('Type'),
          sortable: true,
          formatter: (val, key, item) => {
            return this.dhcpOptsTypeMap.get(val)
          }},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'flag', label: this.$i18n.t('Force Add'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      opts125: [],
      dhcpOptsTypeReverseMap: new Map([
        [this.$i18n.t('Number'), 1],
        [this.$i18n.t('String'), 2],
        [this.$i18n.t('IP address'), 3],
        [this.$i18n.t('Binary'), 4],
        [this.$i18n.t('IP address array'), 5]
      ]),
      dhcpOptsTypeMap: new Map([
        [1, this.$i18n.t('Number')],
        [2, this.$i18n.t('String')],
        [3, this.$i18n.t('IP address')],
        [4, this.$i18n.t('Binary')],
        [5, this.$i18n.t('IP address array')],
        [6, this.$i18n.t('Number(16)')]
      ]),
      radItemForEdit: null,
      portUsageArr: []
    }
  },
  methods: {
    updateIPGroupLogin (login) {
      this.newIPGroups.login = login.toLowerCase()
    },
    IPselected (item) {
      if (item.mask <= 32) {
        this.newIPGroups.ipv4 = item.ip_address + '/' + item.mask.toString()
        this.newIPGroups.ipv6 = ''
      } else {
        this.newIPGroups.ipv6 = item.ip_address + '/' + item.mask.toString()
        this.newIPGroups.ipv4 = ''
      }
      this.rerender_tab_ip_settings += 1
    },
    optSubmit () {
      let tmpOpt = JSON.parse(JSON.stringify(this.newOpt))
      this.dhcpOptionsList.push(tmpOpt)
      this.newOpt = JSON.parse(JSON.stringify(this.emptyOpt))
      this.isOptsModifiedFlag = true
      this.hidemodalOption()
    },
    hidemodalOption () {
      this.$refs.modalOption.hide()
    },
    showmodalOption () {
      this.newOpt = JSON.parse(JSON.stringify(this.emptyOpt))
      this.$refs.modalOption.show()
    },
    saveOpt125 () {
      let opt125 = this.$refs.Option125.getOption125()
      this.dhcpOptionsList.push(opt125.optEl)
      this.opts125.push(opt125.opt125)
      this.isOptsModifiedFlag = true
      this.$refs.MOption125.hide()
    },
    ClickOnDeleteOptsButton (row) {
      this.selectSubnet = row.item
      this.dhcpOptionsList = this.dhcpOptionsList.filter((value) => {
        return (value.option_id + value.value) !== (this.selectSubnet.option_id + this.selectSubnet.value)
      })
      this.opts125 = this.opts125.filter((value) => {
        return value.prepared_val !== this.selectSubnet.value
      })
      this.isOptsModifiedFlag = true
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.radItemForEdit = row
      this.rowRadiusAttr = JSON.parse(JSON.stringify(row.item))
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    editRadiusAttr (radAttr) {
      if (this.radItemForEdit.item) {
        this.radiusAttrItems[this.radItemForEdit.index] = radAttr
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.radiusAttrItems))
      }
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    deleteDHCPoptionsValue (item) {
      this.DHCPoptionsValues = this.DHCPoptionsValues.filter((el, idx, arr) => {
        return el.num !== item.num
      })
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    showFormChargePolicies () {
      for (let i in this.listOfChargePolicy) {
        if (this.ipTrafficService.policy_id === this.listOfChargePolicy[i].policy_id) {
          this.currentChargePolicy = this.listOfChargePolicy[i]
        }
      }
      this.$refs.detailChargePolicies.show()
    },
    hideFormChargePolicies () {
      this.$refs.detailChargePolicies.hide()
    },
    hideAdditionalFeatures () {
      this.$refs.modalDHCPoptions.hide()
    },
    showAdditionalFeatures () {
      this.$refs.modalDHCPoptions.show()
    },
    addDHCPoptionsValues () {
      this.newDHCPoptions.num = ++this.DHCPoptionsValuesIds
      this.DHCPoptionsValues.push(JSON.parse(JSON.stringify(this.newDHCPoptions)))
    },
    addDHCPOptionsToIPGroup () {
      // this.newIPGroups.dhcp_options = []
      for (let option of this.dhcpOptionsList) {
        if (option.option_id === 125) {
          continue
        }
        let isDoublicate = false
        this.newIPGroups.dhcp_options.forEach(el => {
          if (el.id === option.option_id && el.value === option.value) {
            isDoublicate = true
          }
        })
        if (isDoublicate) continue
        let opt = {}
        opt.id = Number(option.option_id)
        opt.type = option.type
        opt.value = option.value
        opt.flag = option.flag ? 1 : 0
        switch (opt.type) {
          case 1: {
            if (Number(opt.value)) {
              opt.value = Number(opt.value)
              break
            } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect INT format'), 'Error')
              return
            }
          }
          case 2: {
            break
          }
          case 3: {
            let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
            if (opt.value.match(goodChars)) {
              opt.value = opt.value
            } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
              return
            }
            break
          }
          case 4: {
            let goodChars = '^[0-9a-fA-F]+$'
            if (opt.value.length % 2 === 0 && opt.value.match(goodChars)) {
              opt.value = opt.values
              break
            } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect BINARY format'), 'Error')
              return
            }
          }
          case 5: {
            opt.addresses = []
            let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
            opt.addresses = opt.value.split(';')
            if (opt.addresses.length) {
              let foundAddresse = opt.addresses.find(el => {
                return !el.match(goodChars)
              })
              if (foundAddresse) {
                this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP_ARRAY format'), 'Error')
                return
              }
              break
            } else {
              this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP_ARRAY format'), 'Error')
              return
            }
          }
        }
        this.newIPGroups.dhcp_options.push(opt)
      }
      for (let opt of this.opts125) {
        let isDoublicate = false
        this.newIPGroups.dhcp_options.forEach(el => {
          if (el.id === opt.option_id && el.value === opt.value) {
            isDoublicate = true
          }
        })
        if (isDoublicate) continue
        let optPrep = {}
        optPrep.type = 4
        optPrep.flag = opt.flag ? 1 : 0
        optPrep.id = 125
        optPrep.value = opt.value
        this.newIPGroups.dhcp_options.push(optPrep)
      }
      this.hideAdditionalFeatures()
    },
    showAddIPGroups () {
      this.newIPGroups = JSON.parse(JSON.stringify(this.emptyIPGroups))
      this.isEditIPGroups = false
      this.$refs.modalIPGroups.show()
    },
    subOpt125Parser (val) {
      let res = '\n SubOptID: ' + parseInt(val.slice(0, 2), 16)
      res = res + ' SubOptLength: ' + parseInt(val.slice(2, 4), 16)
      res = res + ' SubOptString: ' + this.hex_to_ascii(val.slice(4)) + ' (hex:' + val.slice(4) + ')'
      return res
    },
    hex_to_ascii (str1) {
      var hex = str1.toString()
      var str = ''
      for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16))
      }
      return str
    },
    parseOpt125Value (val, flag_) {
      let res = 'Enterprise : '
      let EnterpriseID = val.slice(0, 8)
      res = res + parseInt(EnterpriseID, 16)
      let l = val.slice(8, 10)
      if (l === 0) {
        this.opts125.push({option_id: 125, type: 4, value: val, flag: flag_, prepared_val: res})
        return res
      }
      res = res + ' Length: ' + parseInt(l, 16)
      let currentIndx = 0
      let subOpts = val.slice(10)
      while (subOpts.length > 0) {
        let lenStr = subOpts.slice(2, 4)
        let SOptLen = parseInt(lenStr, 16)
        if (isNaN(SOptLen) || lenStr === '00') {
          break
        }
        let dataLen = 2 * Number(SOptLen)
        let idAndL = 2 + 2 // id = 1 byte(2 character)  Length = 1 byte
        currentIndx = dataLen + idAndL
        res = res + this.subOpt125Parser(subOpts.slice(0, currentIndx))
        subOpts = subOpts.slice(currentIndx)
      }
      this.opts125.push({option_id: 125, type: 4, value: val, flag: flag_, prepared_val: res})
      return res
    },
    async ClickOnEditIPGroupsButton (row) {
      this.selectIPGroups = row.item
      this.newIPGroups = this.selectIPGroups

      for (let opt of this.newIPGroups.dhcp_options) {
        let isDoublicate = false
        this.dhcpOptionsList.forEach(el => {
          if (el.option_id === opt.id && (el.value === opt.value || (opt.id === 125 && el.value === this.parseOpt125Value(opt.value, opt.flag)))) {
            isDoublicate = true
          }
        })
        if (isDoublicate) continue
        if (opt.id !== 125) {
          this.dhcpOptionsList.push(
            {
              option_id: opt.id,
              type: opt.type,
              value: opt.value,
              flag: opt.flag === 1
            })
        } else {
          this.dhcpOptionsList.push(
            {
              option_id: opt.id,
              type: opt.type,
              value: this.parseOpt125Value(opt.value, opt.flag),
              flag: opt.flag === 1
            })
        }
      }
      this.isNotVPN = false
      this.isNotFirewall = false
      this.isDynamic = false
      this.isDelegatedIPv6 = false
      if (this.newIPGroups.flags) {
        if (this.newIPGroups.flags & this.flagNotVPN) {
          this.isNotVPN = true
        }
        if (this.newIPGroups.flags & this.flagNotFirewall) {
          this.isNotFirewall = true
        }
        if (this.newIPGroups.flags & this.flagDynamic) {
          this.isDynamic = true
        }
        if (this.newIPGroups.flags & this.flagDelegatedIPv6) {
          this.isDelegatedIPv6 = true
        }
      }
      this.selectedRadiusPool = this.selectIPGroups.pool_name
      for (let i in this.selectIPGroups.isg_attrs) {
        for (let j in this.ISGattrs) {
          if (this.selectIPGroups.isg_attrs[i].isg_attr_id === this.ISGattrs[j].id) {
            this.ISGattrs[j].isg_attr_value = JSON.parse(JSON.stringify(this.selectIPGroups.isg_attrs[i].isg_attr_value))
          }
        }
      }
      if (this.newIPGroups.switch_id) {
        for (let el of this.$store.getters['Inventory/SWITCHES']) {
          if (el.id === this.newIPGroups.switch_id) {
            this.switchName = el.name
          }
        }
        await this.$store.dispatch('Inventory/GET_SWITCHE_PORTS_USAGE', this.newIPGroups.switch_id).then(response => {
          this.portUsageArr = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCHE_PORTS_USAGE']))
        })
        await this.$store.dispatch('Inventory/GET_SWITCH_IP_PORT_BINDING', this.newIPGroups.switch_id).then(response => {
          this.switchIpPortBinding = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCH_BINDING']))
        })
        let bind = this.switchIpPortBinding.bindings.find(el => {
          return el.port === this.newIPGroups.port_id && el.switch_id === this.newIPGroups.switch_id
        })
        if (bind &&
            bind.enable &&
            this.newIPGroups.ip !== '' &&
            this.newIPGroups.ip !== bind.ip &&
            this.newIPGroups.port_id !== 0) {
          this.$root.$emit('makeToasts', 'warning', this.$i18n.t('IPv4 address is mismatched switch IP-Port binding') +
           ' (' + 'port:' + this.newIPGroups.port_id + ' <-> ip:' + bind.ip + ')',
          'Warning')
        }
      } else {
        this.switchName = ''
      }
      this.selectedDhcpPool = this.newIPGroups.pool_id
      this.selectedNetFlow = this.newIPGroups.nfprovider_id
      this.isEditIPGroups = true
      this.$refs.modalIPGroups.show()
    },
    hideIPGroups () {
      this.$refs.modalIPGroups.hide()
      this.selectedDhcpPool = 0
      this.selectedNetFlow = 0
      this.selectedRadiusPool = ''
      this.switchName = ''
      this.isNotVPN = false
      this.isNotFirewall = false
      this.isDynamic = false
      this.isDelegatedIPv6 = false
      if (this.selectIPGroups) {
        if (this.selectIPGroups.ipv6 === '' && this.selectIPGroups.ipv4 === '') {
          this.selectIPGroups.ipv4 = '[Auto]'
        }
      }
      for (let i in this.ISGattrs) {
        this.ISGattrs[i].isg_attr_value = 'none'
      }
      this.DHCPoptionsValuesIds = 0
      this.DHCPoptionsValues = []
    },
    addIPGroups () {
      if (this.selectedRadiusPool.length === 0 &&
          this.selectedDhcpPool === 0 &&
          this.newIPGroups.ipv4 === '' &&
          this.newIPGroups.ipv6 === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('You must specify at least one of subnests'), 'Error')
        this.$refs.tab_ip_settings.activate()
        return
      }
      if (!this.validationIPv4() || !this.validationIPv6()) {
        return
      }
      if (this.newIPGroups.switch_id) {
        let foundSwitch = this.switchTable.find(el => {
          return el.id === this.newIPGroups.switch_id
        })
        if (foundSwitch) {
          if (this.newIPGroups.port_id < 0 || this.newIPGroups.port_id > foundSwitch.ports_count) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect Port'), 'Error')
            return
          }
        }
      }
      if (this.newIPGroups.vlan_id < 0 || this.newIPGroups.vlan_id > 1000000000) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect VLAN ID'), 'Error')
        return
      }

      this.newIPGroups.pool_name = this.selectedRadiusPool

      for (let i in this.ISGattrs) {
        this.ISGattrs[i].isg_attr_id = this.ISGattrs[i].id
      }
      this.newIPGroups.isg_attrs = JSON.parse(JSON.stringify(this.ISGattrs))
      this.newIPGroups.pool_id = this.selectedDhcpPool
      this.newIPGroups.flags = 0
      this.newIPGroups.flags += this.isNotVPN ? this.flagNotVPN : 0
      this.newIPGroups.flags += this.isNotFirewall ? this.flagNotFirewall : 0
      this.newIPGroups.flags += this.isDynamic ? this.flagDynamic : 0
      if (this.newIPGroups.login.length && this.newIPGroups.password.length && this.isValRadiuspool) {
        this.newIPGroups.flags += this.isDelegatedIPv6 ? this.flagDelegatedIPv6 : 0
      }
      this.newIPGroups.nfprovider_id = this.selectedNetFlow
      if (!this.newIPGroups.ipv4.length && !this.newIPGroups.ipv6.length) {
        this.newIPGroups.ip = '0.0.0.0'
      }
      if (this.newIPGroups.ipv4.length) {
        this.newIPGroups.ip = this.newIPGroups.ipv4.split('/')[0]
        this.newIPGroups.mask = this.newIPGroups.ipv4.split('/')[1]
        if (!Number(this.newIPGroups.mask)) {
          this.newIPGroups.mask = 32
        }
      }
      if (this.newIPGroups.ipv6.length) {
        this.newIPGroups.ip = this.newIPGroups.ipv6.split('/')[0]
        this.newIPGroups.mask = this.newIPGroups.ipv6.split('/')[1]
        if (!Number(this.newIPGroups.mask)) {
          this.newIPGroups.mask = 128
        }
      }
      this.newIPGroups.port_id = Number(this.newIPGroups.port_id)
      this.newIPGroups.vlan_id = Number(this.newIPGroups.vlan_id)

      if (!this.isEditIPGroups) {
        this.IPGroups.push(this.newIPGroups)
      }
      this.DHCPoptionsValuesIds = 0
      this.DHCPoptionsValues = []
      this.hideIPGroups()
      this.$root.$emit('makeToasts')
    },
    ClickOnDeleteIPGroupsButton (row) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "IP Group"?'), this.deleteIPGroup, row.item)
    },
    deleteIPGroup (deleting) {
      this.IPGroups = this.IPGroups.filter((value) => {
        return value !== deleting
      })
    },
    showAddQuotas () {
      this.newQuotas = JSON.parse(JSON.stringify(this.emptyQuotas))
      this.selectedQuotas = this.listOfQuotas[0].value
      this.isEditQuotas = false
      this.$refs.modalQuotas.show()
    },
    ClickOnEditQuotasButton (row) {
      this.selectQuotas = row.item
      this.newQuotas = this.selectQuotas
      this.isEditQuotas = true
      this.$refs.modalQuotas.show()
    },
    hideQuotas () {
      this.$refs.modalQuotas.hide()
    },
    ClickOnDeleteQuotasButton (row) {
      this.selectQuotas = row.item
      this.Quotas = this.Quotas.filter((value) => {
        return value !== this.selectQuotas
      })
      this.hideQuotas()
    },
    addQuotas () {
      if (this.isEditQuotas) {
        if (this.newQuotas.traffic_quota > 0) {
          this.$root.$emit('makeToasts')
          this.hideQuotas()
        }
      } else {
        let foundQuota = this.Quotas.find(el => {
          return el.tclass === this.selectedQuotas
        })
        if (!foundQuota) {
          if (this.newQuotas.traffic_quota > 0) {
            this.newQuotas.tclass = this.selectedQuotas
            for (let i in this.listOfQuotas) {
              if (this.listOfQuotas[i].value === this.selectedQuotas) {
                this.newQuotas.name = this.listOfQuotas[i].text
                break
              }
            }
            this.newQuotas.traffic_quota = Number(this.newQuotas.traffic_quota)
            this.Quotas.push(this.newQuotas)
            this.$root.$emit('makeToasts')
          } else {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Error qouta format'), 'Error')
            return
          }
          this.hideQuotas()
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add qouta value for tclass'), 'Error')
        }
      }
    },
    showTurboMode () {
      this.$refs.turboMode.show()
    },
    hideTurboMode () {
      this.$refs.turboMode.hide()
    },
    showFormCharged () {
      this.$refs.detailCharge.show()
    },
    hideFormCharged () {
      this.$refs.detailCharge.hide()
    },
    showFormAccountingPeriod () {
      this.$refs.accoutingPeriod.show()
    },
    hideAccoutingPeriod () {
      this.$refs.accoutingPeriod.hide()
    },
    showFormHouse () {
      this.isShowHouseUser = true
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.isShowHouseUser = false
      this.$refs.houseUser.hide()
    },
    showFormfreeIP () {
      this.isV4 = true
      this.$refs.freeIp.show()
    },
    showFormfreeIPv6 () {
      this.isV4 = false
      this.$refs.freeIp.show()
    },
    hideFormfreeIP () {
      this.isV4 = true
      this.$refs.freeIp.hide()
    },
    clear () {
      this.ipTrafficService.house_id = 0
    },
    showSwitch () {
      this.$refs.modalSwitch.show()
    },
    hideSwitch () {
      this.$refs.modalSwitch.hide()
    },
    rowClickHandlerSwitch (row) {
      if (this.selectSwitch) {
        this.selectSwitch._rowVariant = ''
      }
      this.selectSwitch = row
      this.newIPGroups.port_id = null
      this.$set(this.selectSwitch, '_rowVariant', 'info')
    },
    rowClickHandlerQuotas (row) {
      if (this.selectQuotas) {
        this.selectQuotas._rowVariant = ''
      }
      this.selectQuotas = row
      this.$set(this.selectQuotas, '_rowVariant', 'info')
    },
    async addSwitch () {
      if (this.selectSwitch) {
        this.newIPGroups.switch_id = this.selectSwitch.id
        await this.$store.dispatch('Inventory/GET_SWITCHE_PORTS_USAGE', this.newIPGroups.switch_id).then(response => {
          this.portUsageArr = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCHE_PORTS_USAGE']))
        })

        this.hideSwitch()
        this.switchName = this.selectSwitch.name
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select Switch'), 'Error')
      }
    },
    clearSwitch () {
      this.switchName = ''
      this.newIPGroups.switch_id = 0
      this.newIPGroups.vlan_id = 0
      this.newIPGroups.port_id = 0
      this.selectedDhcpPool = 0
    },
    rowClickHandlerIPGroups (row) {
      if (this.selectIPGroups) {
        this.selectIPGroups._rowVariant = ''
      }
      this.selectIPGroups = row
      for (let i in this.switchTable) {
        if (this.switchTable[i].id === this.selectIPGroups.switch_id) {
          this.switchName = this.switchTable[i].name
        }
        if (this.selectIPGroups.switch_id === 0) {
          this.switchName = ''
        }
      }
      this.$set(this.selectIPGroups, '_rowVariant', 'info')
    },
    validationIPv4 () {
      if (this.newIPGroups.ipv4 !== '') {
        let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
        let valipv4 = this.newIPGroups.ipv4.split('/')[0]
        if (valipv4.match(goodChars)) {
          return true
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
          return false
        }
      } else {
        return true
      }
    },
    validationIPv6 () {
      if (this.newIPGroups.ipv6 !== '') {
        let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
        let valipv6 = this.newIPGroups.ipv6.split('/')[0]
        if (valipv6.match(goodChars)) {
          return true
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
          return false
        }
      } else {
        return true
      }
    },
    addCoefSchemeToSlink (newSlinkId) {
      if ((!this.isEdit && this.ipTrafficService.scheme_id > 0) ||
     (this.ipTrafficServiceEdit !== null &&
     this.ipTrafficServiceEdit.coefficientschedulelink === undefined &&
     this.ipTrafficService.scheme_id > 0)) {
        let coefSchedule = {items: []}
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === this.ipTrafficService.scheme_id) {
            coefSchedule.items = el.items
          }
        }
        let responseCoefScheduleId = this.$store.dispatch('Users/CREATE_COEFFICIENT_SCHEDLE', coefSchedule)
        responseCoefScheduleId.then(responseCoefScheduleId => {
          let newCoefScheduleId = responseCoefScheduleId.data.coefficient_schedule_id
          let schedule = {
            scheme_id: this.ipTrafficService.scheme_id,
            slink_id: Number(newSlinkId),
            schedule_id: Number(newCoefScheduleId),
            change_policy: 0
          }
          this.$store.dispatch('Users/CREATE_UERS_SERVICELINKS_COEFFICIENT_SCHEDLE', schedule)
        })
      }
    },
    async saveServiceLink () {
      if (this.ipTrafficService.accounting_period_id === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
      } else if (this.IPGroups.length === 0) {
        this.tabIPGroups = true
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('IP groups table is empty'), 'Error')
      } else {
        let tmpIpTrafficService = JSON.parse(JSON.stringify(this.ipTrafficService))
        tmpIpTrafficService.traffic_quota = this.Quotas
        tmpIpTrafficService.traffic_quota.forEach(el => { el.traffic_quota = Number(el.traffic_quota) })
        tmpIpTrafficService.cost_coef = tmpIpTrafficService.cost_coef / 100
        tmpIpTrafficService.expire_date = this.infinityDate ? 2000000000 : tmpIpTrafficService.expire_date
        tmpIpTrafficService.ip_group = this.IPGroups
        tmpIpTrafficService.ip_group.forEach(item => {
          item.mask = Number(item.mask)
        })
        tmpIpTrafficService.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0
        if (this.isEdit) {
          tmpIpTrafficService.slink_id = this.currentService.service_link_id
        } else {
          tmpIpTrafficService.account_id = this.selectedAccount
          tmpIpTrafficService.service_id = this.currentService.service_id
          tmpIpTrafficService.user_id = this.currentUser.user_id
        }
        let response = this.isEdit
          ? this.$store.dispatch('Users/UPDATE_IP_TRAFFIC_SERVICE_LINK', tmpIpTrafficService)
          : this.$store.dispatch('Users/CREATE_IP_TRAFFIC_SERVICE_LINK', tmpIpTrafficService)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
            let radiusAttr = {
              'set_object_id': 0,
              'set_type': 10000,
              'attrs': []
            }
            for (let attr of this.radiusAttrItems) {
              if (typeof attr.expire_date === 'string') {
                attr.expire_date = attr.expire_date === moment(2000000000 * 1000).format('YYYY-MM-DDTHH:mm') ? 2000000000 : Number(Date.parse(attr.expire_date)) / 1000
              }
            }
            radiusAttr.attrs = this.radiusAttrItems
            if (this.isEdit) {
              radiusAttr.set_object_id = this.currentService.service_link_id
            } else {
              radiusAttr.set_object_id = response.data.service_link_id
            }
            this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', radiusAttr)

            let newSlinkId = response.data.service_link_id ? response.data.service_link_id : this.currentService.service_link_id
            this.addCoefSchemeToSlink(newSlinkId)

            this.hideSelectService()
            this.$root.$emit('makeToasts')
          }
        })
      }
    },
    coeffSchemeChanged (schemeId) {
      if (schemeId === 0) {
        this.ipTrafficService.cost_coef = 100
      } else {
        let newCostCoef = 100
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === schemeId) {
            for (let elIt of el.items) {
              if (elIt.delay === 0) {
                newCostCoef = elIt.coeff * 100
                break
              }
            }
            break
          }
        }
        this.ipTrafficService.cost_coef = Math.round(newCostCoef)
      }
    }
  },
  async mounted () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 7, object_id: 0})
    this.$store.dispatch('ReferenceBooks/GET_FREE_IP_OF_BUILDINGS_BY_UID', this.currentUser.user_id)
    this.$store.dispatch('Inventory/GET_SWITCHES')
    this.$store.dispatch('Inventory/GET_DHCP_POOLS')
    this.$store.dispatch('Settings/GET_NETFLOW_PROVIDERS')
    await this.$store.dispatch('Tariffing/GET_TRAFFIC_CLASSES_LIST')
    await this.$store.dispatch('Settings/GET_CUSTOM_ISG_ATTRIBUTES').then(response => {
      this.ISGattrs = this.$store.getters['Settings/CUSTOM_ISG_ATTRIBUTES']
      for (let i in this.ISGattrs) {
        this.ISGattrs[i].isg_attr_value = 'none'
      }
    })
    this.$store.dispatch('Settings/GET_IP_POOLS')
    this.ipTrafficService.scheme_id = this.currentService.scheme_id
    this.coeffSchemeChanged(this.currentService.scheme_id)
    if (this.isEdit) {
      this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SLINK', {slink_id: this.currentService.service_link_id})
      this.$store.dispatch('Users/GET_IP_TRAFFIC_SERVICE_LINK', this.currentService.service_link_id).then(response => {
        this.ipTrafficServiceEdit = JSON.parse(JSON.stringify(this.$store.getters['Users/IP_TRAFFIC_SERVICE_LINK']))
        this.ipTrafficService.comment = this.ipTrafficServiceEdit.periodicservicelink.comment
        this.ipTrafficService.start_date = this.ipTrafficServiceEdit.periodicservicelink.start_date
        this.ipTrafficService.expire_date = this.ipTrafficServiceEdit.periodicservicelink.expire_date
        this.rerenderStartDate += 1
        this.rerenderExpireDate += 1
        this.infinityDate = this.ipTrafficServiceEdit.periodicservicelink.expire_date === 2000000000
        this.ipTrafficService.cost_coef = this.ipTrafficServiceEdit.periodicservicelink.cost_coef * 100
        this.ipTrafficService.policy_id = this.ipTrafficServiceEdit.periodicservicelink.policy_id
        this.ipTrafficService.house_comment = this.ipTrafficServiceEdit.periodicservicelink.house_comment
        this.ipTrafficService.accounting_period_id = this.ipTrafficServiceEdit.periodicservicelink.accounting_period_id
        this.ipTrafficService.house_id = this.ipTrafficServiceEdit.periodicservicelink.house_id
        this.ipTrafficService.charged_in_curr_period = Number.parseFloat(this.ipTrafficServiceEdit.periodicservicelink.charged_in_curr_period).toFixed(3)
        if (this.ipTrafficServiceEdit.coefficientschedulelink) {
          this.ipTrafficService.scheme_id = this.ipTrafficServiceEdit.coefficientschedulelink.scheme_id
        }
        if (this.ipTrafficServiceEdit.bandwidth.in !== 0) {
          this.dynamicShapingIn = this.ipTrafficServiceEdit.bandwidth.in
        }
        if (this.ipTrafficServiceEdit.bandwidth.out !== 0) {
          this.dynamicShapingOut = this.ipTrafficServiceEdit.bandwidth.out
        }
        this.dynamicShaping = this.dynamicShapingIn + '/' + this.dynamicShapingOut
        this.IPGroups = this.ipTrafficServiceEdit.ip_group.items
        for (let i in this.IPGroups) {
          if (this.IPGroups[i].pool_id !== 0 && this.IPGroups[i].ip === '0.0.0.0') {
            this.IPGroups[i].ipv4 = '[Auto]'
            this.IPGroups[i].ipv6 = ''
          } else {
            if (this.IPGroups[i].ip_family === 4) {
              this.IPGroups[i].ipv4 = this.IPGroups[i].ip + '/' + this.IPGroups[i].mask
              this.IPGroups[i].ipv6 = ''
            }
            if (this.IPGroups[i].ip_family === 6) {
              this.IPGroups[i].ipv6 = this.IPGroups[i].ip + '/' + this.IPGroups[i].mask
              this.IPGroups[i].ipv4 = ''
            }
          }
          if (this.ipTrafficServiceEdit.coefficientschedulelink) {
            this.ipTrafficService.scheme_id = this.ipTrafficServiceEdit.coefficientschedulelink.scheme_id
          }
        }
        this.Quotas = this.ipTrafficServiceEdit.iptrafficServiceLink.traffic_quota.filter(function (value) {
          return value.tclass !== 0
        })
        for (let i in this.Quotas) {
          for (let el of this.$store.getters['Tariffing/TRAFFIC_CLASSES_LIST']) {
            if (this.Quotas[i].tclass === el.tclass_id) {
              this.Quotas[i].name = el.name + ' (' + el.tclass_id + ')'
            }
          }
        }
      })

      this.radiusAttrItems = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_SLINK']))
      for (let el of this.radiusAttrItems) {
        el.value = el.attr_value
        if (el.tag && (el.vendor === 0)) {
          el.value = ':' + el.tag + ':' + el.attr_value
        }
        switch (el.attr_type) {
          case 1:
            el.attrType = this.$i18n.t('Number')
            break
          case 2:
            el.attrType = this.$i18n.t('String')
            break
          case 3:
            el.attrType = 'IP'
            break
          case 4:
            el.attrType = this.$i18n.t('Binary')
            break
        }
      }
      if (this.newIPGroups.switch_id) {
        await this.$store.dispatch('Inventory/GET_SWITCHE_PORTS_USAGE', this.newIPGroups.switch_id).then(response => {
          this.portUsageArr = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCHE_PORTS_USAGE']))
        })
        await this.$store.dispatch('Inventory/GET_SWITCH_IP_PORT_BINDING', this.selectSwitch.id).then(response => {
          this.switchIpPortBinding = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCH_BINDING']))
        })
      }
    } else {
      this.ipTrafficService.policy_id = this.currentService.policy_id
      this.ipTrafficService.accounting_period_id = this.accountingPeriodId ? this.accountingPeriodId : 0
    }
    this.listToShowOfDhcpPool = this.listOfDhcpPool
    if (this.currentService.addByDefault) {
      this.saveServiceLink()
    }
  },
  computed: {
    registrySettings () {
      return JSON.parse(JSON.stringify(this.$store.getters['Settings/REGISTRY_SETTINGS']))
    },
    isEnabledIpPortLink () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === 'set_ipgroup_static_ip_by_switch_ip_port'
      })
      return tmp.length ? tmp[0].raw_values[0].value === '1' : null
    },
    portState () {
      for (let el of this.portUsageArr) {
        if (el.port === Number(this.newIPGroups.port_id)) { return false }
      }

      return true
    },
    radAttrsSlink () {
      return this.$store.getters['Tariffing/RADIUS_ATTR_SLINK']
    },
    listOfDhcpPool () {
      let tmp = []
      for (let el of this.$store.getters['Inventory/DHCP_POOLS']) {
        let newEl = {
          value: el.id,
          text: el.gateway + '/' + el.netmask + ' (' + el.id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    listOfRadiusPool () {
      let tmp = [{value: '', text: ''}]
      for (let el of this.$store.getters['Settings/IP_POOLS']) {
        let newEl = {
          value: el.name,
          text: el.name,
          ip: el.ip
        }
        tmp.push(newEl)
      }
      return tmp
    },
    listOfFreeIPs () {
      let tmp = [{value: '', text: ''}]
      this.$store.getters['ReferenceBooks/FREE_IPS_OF_BUILDING'].forEach(el => {
        tmp.push({
          value: el.ip_address + '/' + el.mask,
          text: el.ip_address + '/' + el.mask + '[' + el.zone_name + ']'
        })
      })
      return tmp
    },
    listOfNetFlow () {
      let tmp = [{value: 0, text: this.$i18n.t('Any')}]
      for (let el of this.$store.getters['Settings/NETFLOW_PROVIDERS']) {
        let newEl = {
          value: el.provider_id,
          text: el.ip_address
        }
        tmp.push(newEl)
      }
      return tmp
    },
    switchTable () {
      return this.$store.getters['Inventory/SWITCHES']
    },
    listOfQuotas () {
      let tmp = []
      for (let el of this.$store.getters['Tariffing/TRAFFIC_CLASSES_LIST']) {
        let newEl = {
          value: el.tclass_id,
          text: el.name + ' (' + el.tclass_id + ')'
        }
        tmp.push(newEl)
      }
      return tmp
    },
    selectAccountingPeriod () {
      let selectAccountingPeriod = ''
      if (this.ipTrafficService.accounting_period_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))) {
          if (el.id === this.ipTrafficService.accounting_period_id) {
            el.begin = this.$root.getMomentWithTZDelta(Number(el.begin)).format('MM-DD-YYYY')
            el.end = this.$root.getMomentWithTZDelta(Number(el.end)).format('MM-DD-YYYY')
            selectAccountingPeriod = el.begin + ' / ' + el.end + ' (' + el.id + ')'
          }
        }
      }
      return selectAccountingPeriod
    },
    userHouse () {
      let userHouse = ''
      if (this.ipTrafficService.house_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/BUILDINGS']))) {
          if (el.house_id === this.ipTrafficService.house_id) {
            if (el.post_code.length > 0) {
              userHouse += el.post_code + ', '
            }
            if (el.country.length > 0) {
              userHouse += el.country + ', '
            }
            if (el.region.length > 0) {
              userHouse += el.region + ', '
            }
            if (el.city.length > 0) {
              userHouse += el.city + ', '
            }
            if (el.street.length > 0) {
              userHouse += el.street + ', '
            }
            if (el.number.length > 0) {
              userHouse += el.number + ', '
            }
            if (el.building.length > 0) {
              userHouse += el.building + ', '
            }
            userHouse += '(' + el.house_id + ')'
            break
          }
        }
        this.$store.dispatch('ReferenceBooks/GET_FREE_IP_OF_BUILDINGS', this.ipTrafficService.house_id)
      }
      return userHouse
    },
    computedNewIPGroups () {
      return Object.assign({}, this.newIPGroups)
    }
  },
  watch: {
    selectSwitch: async function (val) {
      await this.$store.dispatch('Inventory/GET_SWITCH_IP_PORT_BINDING', this.selectSwitch.id).then(response => {
        this.switchIpPortBinding = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCH_BINDING']))
      })
    },
    computedNewIPGroups: {
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal.ipv6.length) {
          this.newIPGroups.ipv4 = ''
        }
        if (newVal.ipv4.length) {
          this.newIPGroups.ipv6 = ''
        }
        if (newVal.port_id !== oldVal.port_id && this.isEnabledIpPortLink) {
          const binding = this.switchIpPortBinding.bindings.find((el) =>
            el.port === Number(newVal.port_id)
          )
          if (!binding) {
            return
          }
          if (!binding.enable) {
            return
          }
          const defaultMask = '32'
          this.newIPGroups.ip = binding.ip
          this.newIPGroups.mask = defaultMask
          this.newIPGroups.ipv4 = binding.ip + '/' + defaultMask
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Static IPv4 address assigned') + ': ' + this.newIPGroups.ipv4)
        }
      }
    },
    radAttrsSlink: function (items) {
      this.radiusAttrItems = items
      for (let el of this.radiusAttrItems) {
        el.value = el.attr_value
        if (el.tag && (el.vendor === 0)) {
          el.value = ':' + el.tag + ':' + el.attr_value
        }
        switch (el.attr_type) {
          case 1:
            el.attrType = this.$i18n.t('Number')
            break
          case 2:
            el.attrType = this.$i18n.t('String')
            break
          case 3:
            el.attrType = 'IP'
            break
          case 4:
            el.attrType = this.$i18n.t('Binary')
            break
        }
      }
    },
    selectedDhcpPool: function () {
      if (this.selectedDhcpPool !== 0) {
        this.newIPGroups.ipv4 = ''
        this.newIPGroups.ipv6 = ''
      }
    },
    selectedRadiusPool: function () {
      if (this.selectedRadiusPool) {
        this.newIPGroups.ipv4 = ''
        this.newIPGroups.ipv6 = ''
      }
      if (this.selectedRadiusPool) {
        for (let el of this.listOfRadiusPool) {
          if (this.selectedRadiusPool === el.value) {
            if (el.ip.includes(':')) {
              this.isValRadiuspool = true
            } else {
              this.isValRadiuspool = false
            }
          } else {
            this.isValRadiuspool = false
          }
        }
      }
    },
    switchName: function (newVal) {
      for (let i in this.switchTable) {
        if (this.switchTable[i].id === this.newIPGroups.switch_id) {
          if (this.switchTable[i].dhcp_pools.length) {
            this.listToShowOfDhcpPool = this.listOfDhcpPool.filter((el) => {
              for (let j in this.switchTable[i].dhcp_pools) {
                if (this.switchTable[i].dhcp_pools[j] === el.value) {
                  return true
                }
              }
              return false
            })
          }
          break
        }
      }
      if (this.selectedDhcpPool !== 0) {
        let isFound = false
        for (let el of this.listToShowOfDhcpPool) {
          if (el.value === this.selectedDhcpPool) {
            isFound = true
          }
        }
        this.selectedDhcpPool = isFound ? this.selectedDhcpPool : 0
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formIPTraffic.vue